import { render, staticRenderFns } from "./StepperTabs.vue?vue&type=template&id=2a39cc60&"
import script from "./StepperTabs.vue?vue&type=script&lang=js&"
export * from "./StepperTabs.vue?vue&type=script&lang=js&"
import style0 from "./StepperTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports